export default {
  'contactUs.title': '联系我们',
  'contactUs.userInfo': '用户信息',
  'contactUs.firstName': '名字',
  'contactUs.lastName': '姓氏',
  'contactUs.email': '邮箱',
  'contactUs.phone': '手机号码',
  'contactUs.jobTitle': '职位',
  'contactUs.howCanWeHelp': '我们能为您做些什么？',
  'contactUs.companyInfo': '公司信息',
  'contactUs.companyName': '公司名称',
  'contactUs.companyIndustry': '公司行业',
  'contactUs.companySize': '公司规模',
  'contactUs.submit': '提交',
  'contactUs.submitSuccess': '提交成功，我们会尽快联系您',
  'contactUs.submitFail': '提交失败',
  'contactUs.firstNameRequired': '名字不可为空',
  'contactUs.lastNameRequired': '姓氏不可为空',
  'contactUs.emailRequired': '邮箱不可为空',
  'contactUs.emailInvalid': '请输入合法的邮箱地址',
  'contactUs.phoneRequired': '手机号码不可为空',
  'contactUs.phoneInvalid': '请输入合法的手机号',
  'contactUs.jobTitleRequired': '职位不可为空',
  'contactUs.companyNameRequired': '公司名称不可为空',
  'contactUs.companyIndustryRequired': '公司行业不可为空',
  'contactUs.companySizeRequired': '公司规模不可为空',
  'contactUs.helpRequired': '需求描述不可为空',
};
